module.exports = __webpack_public_path__ + "assets/img/o4.f45bee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/o4.jpg
// module id = EJqr
// module chunks = 1